import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	user: {
		fname: "Victor Umedum",
		email: "victorumedum@gmail.com",
		role: "Admin",
	},
};

export const userSlice = createSlice({
	name: "userData",
	initialState,

	reducers: {
		setUser: (state, action) => {
			state.user = action.payload;
		},

		deleteUser: (state, action) => {
			state.user = "";
		},
	},
});

export const { setUser, deleteUser } = userSlice.actions;

export default userSlice.reducer;
